import AbstractListResource from './abstract/abstract-list-resource';
import {ActionType, Resource} from 'sdk/src/defines';
import SubscriberProfile from './items/subscriber-profile';
import {SortFunc} from '../utility/types';
import {sortAsc} from '../utility/utils';

class SubscriberProfiles extends AbstractListResource<SubscriberProfile> {

    public resourceType: Resource = Resource.SUBSCRIBER_PROFILES;

    public resourceItemClass: typeof SubscriberProfile = SubscriberProfile;

    public sort: SortFunc = sortAsc('createdAt');

    public allowedActions: ActionType[] = [
        ActionType.LIST,
        ActionType.UPDATE,
        ActionType.DELETE,
        ActionType.CREATE,
        ActionType.UPLOAD,
    ];

    public getConnectedResourceTypes(): Resource[] {
        return [Resource.SUBSCRIBERS];
    }
}

export {SubscriberProfiles, SubscriberProfile};
export default new SubscriberProfiles();